import AxiosClient from "../../../services/axios.services";

class EducationLevelServices {
  getEducationLevel = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_formacion_nivel_educativo/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getEducationLevelById = (id) =>
    AxiosClient.get(
      `/api/app/descriptor_perfil_formacion_nivel_educativo/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveEducationLevel = (data) =>
    AxiosClient.post(
      "/api/app/descriptor_perfil_formacion_nivel_educativo/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editEducationLevel = (id, data) =>
    AxiosClient.put(
      `/api/app/descriptor_perfil_formacion_nivel_educativo/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteEducationLevel = (id) =>
    AxiosClient.delete(
      `/api/app/descriptor_perfil_formacion_nivel_educativo/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new EducationLevelServices();
